var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row flex-center q-mt-sm q-mb-xs"},[_c('div',{staticClass:"flex flex-center col-12"},[_c('img',{staticClass:"logo",attrs:{"src":require('@/assets/logos/lareinadigital.png')}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }